import { ReservationSettingDto } from 'gleblu-socket-api';

import ReservationSetting from '../interfaces/ReservationSetting';

export function fromDto(reservationSettingDto: ReservationSettingDto): ReservationSetting {
  const { uuid, durationA, durationB, durationC, ...others } = reservationSettingDto;
  return {
    uuid,
    duration: [durationA, durationB, durationC],
    ...others,
  };
}

export function toDto(reservation: ReservationSetting): ReservationSettingDto {
  const { uuid, duration, ...others } = reservation;
  const [durationA, durationB, durationC] = duration;

  return {
    uuid,
    durationA,
    durationB,
    durationC,
    ...others,
  };
}
